import {createPerformanceDebugTrace, type PerformanceDebugData} from "@pg-mono/performance-debug";

export const CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP = "cloudflare_turnstile";
export const RP_LEAD_FORMS_PERFORMANCE_GROUP = "rp_lead_forms";

export const createRpLeadPerformanceDebugTrace = (flow: string, initialData?: PerformanceDebugData) =>
    createPerformanceDebugTrace(flow, initialData, {group: RP_LEAD_FORMS_PERFORMANCE_GROUP});
import {createPerformanceDebugTrace, type PerformanceDebugData} from "@pg-mono/performance-debug";

export const CLOUDFLARE_TURNSTILE_PERFORMANCE_GROUP = "cloudflare_turnstile";
export const RP_LEAD_FORMS_PERFORMANCE_GROUP = "rp_lead_forms";

export const createRpLeadPerformanceDebugTrace = (flow: string, initialData?: PerformanceDebugData) =>
    createPerformanceDebugTrace(flow, initialData, {group: RP_LEAD_FORMS_PERFORMANCE_GROUP});
